<script lang="ts">
    import { createEventDispatcher } from 'svelte';
    import type { NullableTextInputDefinition } from 'header/types';

    interface Props {
        field: NullableTextInputDefinition;
    }

    let { field }: Props = $props();

    const dispatch = createEventDispatcher();

    const onBlur = (e: { currentTarget: HTMLInputElement }) => {
        dispatch('change', {
            field: {
                ...field,
                value: e.currentTarget.value,
            },
        });
    };
</script>

<input
    class="input"
    type="text"
    disabled={field.changeable === false}
    value={field.value}
    onblur={onBlur}
/>

<style lang="scss" scoped>
    .input {
        width: 100%;
    }
</style>
